import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Card,
  CardContent,
  Container,
  Button,
} from "@mui/material";
import * as services from "./../../services/customer";
import img from "../../images/profile_example.jpg";
import { useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import AddIcon from "@mui/icons-material/Add";

export default function CustomerListPage() {
  const [search, setSearch] = useState("");
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCustomer()

  }, []);
  const fetchCustomer = async () => {
    try {
        let res = await services.getCustomersList();
      const rawData = res.data?.data || [];
      setCustomers(rawData)
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };
  const filtered = customers.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.cars.some((car) => car.license.includes(search))
  );

  const handleSelect = (customer) => {
    navigate(`/customers/edit?customer_id=${customer.id}`);
  };
  const handleCreateClick = () => {
    navigate(`/customers/create`);
  };
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
            <AppBreadcrumbs />
            <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        mt={2}
      >
        <Typography variant="h5">เลือกซัพพลายเออร์</Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleCreateClick}
        >
          ซัพพลายเออร์ใหม่
        </Button>
      </Box>
      <TextField
        fullWidth
        placeholder="ค้นหาชื่อซัพพลายเออร์ หรือทะเบียนรถ"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 4 }}
      />

      <Grid container spacing={2}>
        {filtered.map((customer) => (
          <Grid item xs={12} sm={12} md={6} key={customer.id}>
            <Card
              onClick={() => handleSelect(customer)}
              sx={{
                display: "flex",
                cursor: "pointer",
                backgroundColor: "#e0f2f1",
                borderLeft: "5px solid #00897b",
                "&:hover": { boxShadow: 4 },
                height: 150,
              }}
            >
              {/* รูปภาพซัพพลายเออร์ */}
              <Box
                component="img"
                src={customer.img ==null ? img : customer.img}
                alt={customer.name}
                sx={{
                  width: 150,
                  height: "100%",
                  objectFit: "cover",
                  borderRight: "1px solid #ccc",
                }}
              />

              {/* ข้อมูลซัพพลายเออร์ */}
              <CardContent sx={{ flex: 1 }}>
                <Typography fontWeight="bold" fontSize={18}>
               {customer.name}
                </Typography>

                <Typography fontSize={14} color="text.secondary" sx={{ mt: 1 }}>
                  {customer.cars.map((car) => (
                    <div key={car.id}>
                      รถกระบะ ({car.license}) – {car.weight} กก.
                    </div>
                  ))}
                </Typography>

                <Typography fontSize={16} sx={{ mt: 1 }}>
                  {customer.personType === "normal"
                    ? "บุคคลธรรมดา"
                    : "นิติบุคคล"}
                  {customer.group ? `, กลุ่ม ${customer.group}` : ""}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
